export function LegacyBursonRequestInvoiceCtrl (
  $uibModalInstance,
  $scope,
  invoice,
  LegacyBursonInvoices,
  messages
) {
  $scope.invoice = invoice;

  $scope.LegacyBursonInvoices = new LegacyBursonInvoices();

  $scope.continue = function () {
    $scope.LegacyBursonInvoices.getBursonItems($scope.invoice)
    .then(data => {
      $uibModalInstance.close(data);
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.overwrite = function () {
    $scope.LegacyBursonInvoices.overwrite($scope.invoice)
    .then(data => {
      $uibModalInstance.close(data);
    })
    .catch(err => {
      $uibModalInstance.dismiss();
    });
  };
}